'use client';
import { useRouter } from 'next/navigation';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { NotFoundBox, NotFoundText } from './styles';
import { ROUTES } from '../../../constants';
import { HeadlineMedium } from '../../styles';
import { FilledButton } from '../buttons';

const NotFoundComponent = () => {
    const router = useRouter();

    return (
        <NotFoundBox>
            <HeadlineMedium>Seite nicht gefunden</HeadlineMedium>
            <NotFoundText>
                Die gewünschte Seite konnte nicht gefunden werden. Bitte gehen Sie zur Startseite.
            </NotFoundText>
            <FilledButton
                icon={<RoomOutlinedIcon />}
                label={'Zur Startseite'}
                onClick={() => router.push(ROUTES.Home)}
            />
        </NotFoundBox>
    );
};

export { NotFoundComponent };
